(function () {
  if (window.__cartLegalConsentInit) return;
  window.__cartLegalConsentInit = true;

  function initBlock(el) {
    if (el.__legalReady) return;
    el.__legalReady = true;

    var checkboxes = Array.from(el.querySelectorAll('[data-legal-checkbox]'));
    if (!checkboxes.length) return;

    // Find [data-cart-checkout-buttons] — walk forward through siblings
    var sibling = el.nextElementSibling;
    while (sibling && !sibling.hasAttribute('data-cart-checkout-buttons')) {
      sibling = sibling.nextElementSibling;
    }
    var checkoutWrap = sibling;

    // Also try within parent if not found as sibling
    if (!checkoutWrap) {
      checkoutWrap = el.parentElement && el.parentElement.querySelector('[data-cart-checkout-buttons]');
    }

    if (!checkoutWrap) return;

    var fieldset = checkoutWrap.querySelector('fieldset[data-cart-checkout-button]') || checkoutWrap.querySelector('fieldset');
    var checkoutBtn = checkoutWrap.querySelector('button[name="checkout"]');
    var dynamicBtns = checkoutWrap.querySelector('[data-additional-checkout-button]');

    // Also intercept the form's submit event to block if unchecked
    var form = el.closest('form');

    if (!checkoutBtn) return;

    function allChecked() {
      return checkboxes.every(function (cb) { return cb.checked; });
    }

    function setLocked(locked) {
      // Disable the button
      checkoutBtn.disabled = locked;
      // Disable the fieldset (blocks all children including dynamic buttons)
      if (fieldset) fieldset.disabled = locked;
      // Visually dim dynamic checkout buttons (Apple Pay etc.)
      if (dynamicBtns) {
        dynamicBtns.style.pointerEvents = locked ? 'none' : '';
        dynamicBtns.style.opacity = locked ? '0.35' : '';
      }
      // Add/remove a visual class on the wrapper
      checkoutWrap.classList.toggle('cart-legal-consent--locked', locked);
    }

    function syncAttributes() {
      var attrs = {};
      checkboxes.forEach(function (cb) {
        var key = cb.getAttribute('data-legal-checkbox') === 'distance'
          ? 'distance_sales_agreement_accepted'
          : 'preliminary_form_accepted';
        attrs[key] = cb.checked ? 'true' : '';
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }

    // Block form submit if unchecked (catches any programmatic submission too)
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!allChecked()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          // Shake the consent block to draw attention
          el.classList.add('cart-legal-consent--shake');
          setTimeout(function () { el.classList.remove('cart-legal-consent--shake'); }, 600);
        }
      }, true); // capture phase — runs before theme handlers
    }

    // Init locked
    setLocked(true);

    checkboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        setLocked(!allChecked());
        syncAttributes();
      });
    });
  }

  function scanAll() {
    document.querySelectorAll('[data-cart-legal-consent]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  // Re-scan when cart drawer injects new HTML
  new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-cart-legal-consent]') || node.querySelector('[data-cart-legal-consent]')) {
          found = true;
        }
      });
    });
    if (found) scanAll();
  }).observe(document.body, { childList: true, subtree: true });
})();
